const acceptFileUpload =
  '.jpg,.jpeg,.png,.heic,.jfif,.pdf,.sheet,.document,.msword,.docx,.xlsx,.pptx,.pptm,.ppt,.potx,.potm,.pot';

const acceptFileMicrosoft = '.pdf,.sheet,.document,.msword,.docx,.xlsx,.pptx,.pptm,.ppt,.potx,.potm,.pot';

export { acceptFileUpload, acceptFileMicrosoft };
